// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import KwPanel from '../../../common/KwPanel';

import { deletePackageType } from '../../../../actions/packageTypeActions';
import { toast } from 'react-toastify';
import Button from '../../../common/Button';
import ConfirmationHeader from '../../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';

function DeletePackageType({ done, id, cancel, deletePackageType }) {
  const { t } = useTranslation();
  const handleDelete = () => {
    deletePackageType(id)
      .then(() => {
        toast.success(t('Package type successfully deleted'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to delete package type'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          testId="confirm-delete-package-button"
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the package type')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}


function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = {
  deletePackageType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeletePackageType);
